function applyCustomizations() {
  const legends = document.querySelectorAll("fieldset legend.form__label");
  let typeFieldset;

  legends.forEach(legend => {
    if (legend.textContent.trim() === "Type") {
      typeFieldset = legend.closest("fieldset");
    }
  });

  if (typeFieldset) {
    const singleBagsInput = typeFieldset.querySelector('input[value="Single Bags"]');
    const subscriberInput = typeFieldset.querySelector('input[value="For Subscribers"]');
    const subscriberLabel = subscriberInput
      ? typeFieldset.querySelector(`label[for="${subscriberInput.id}"]`)
      : null;

    /**
     * selecting the singe bag option
     */
    console.log(singleBagsInput.checked)
    if (singleBagsInput && !singleBagsInput.checked) {
      singleBagsInput.checked = true;
      singleBagsInput.dispatchEvent(new Event("change", { bubbles: true }));
      setTimeout(() => {
        document.activeElement.blur();
      }, 100);
    }

    /**
     * hiding the "for subscribers option" but still it show a little flicker to solve that css has been used if you remove this part then also fine
     */
    // if (subscriberInput && subscriberLabel) {
    //   subscriberInput.style.display = "none";
    //   subscriberLabel.style.display = "none";
    // }
  }
}


// Run once after DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  applyCustomizations();

  // Then start observing for future changes
  const observer = new MutationObserver(applyCustomizations);
  observer.observe(document.body, { childList: true, subtree: true });
});



// function selectSingleBags() {
//   const field_sets = document.querySelectorAll("fieldset");
  
//   field_sets.forEach(fs => {
//     const legend = fs.querySelector("legend");
//     if (legend && legend.textContent.trim() === "Type") {
//         fs.style.display="none"
//       const input = fs.querySelector('input[value="Single Bags"]');
//       if (input) {
//         const label = fs.querySelector(`label[for="${input.id}"]`);
//         if (label && !input.checked) { 
//           label.click();
//         }
//       }
//     }
//   });
// }

// // Run once on page load
// document.addEventListener("DOMContentLoaded", selectSingleBags);

// // Watch for changes in DOM (new field_sets, inputs, etc.)
// const observer = new MutationObserver(() => {
//   const field_sets = document.querySelectorAll("fieldset");
  
//   field_sets.forEach(fs => {
//     const legend = fs.querySelector("legend");
//     if (legend && legend.textContent.trim() === "Type") {
//         fs.style.display="none"
//     }
//   });
// });

// // Start observing the whole document
// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
// });
